"use client";

import Link from "next/link";
import IconArrowRight from "@/app/(components)/generics/Icons/IconArrowRight";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PageParams } from "@/app/types/common/DefaultProps";
import { ACTIVATION_STAGE_ACCENTS, ActivationStageKey } from "./Dashboard.logic";
import styles from "./Dashboard.module.css";

type Props = {
  params: PageParams;
  stage: ActivationStageKey;
  titleKey: TKey;
  ctaKey: TKey;
  path: string;
  count?: number;
};

export default function DashboardTaskCard(props: Props) {
  const T = useT();
  const { params, stage, titleKey, ctaKey, path, count } = props;

  const title = (T(titleKey) as string).replace("{{count}}", String(count ?? 0));
  const cta = T(ctaKey) as string;

  return (
    <Link href={`/${params.lang}${path}`} className={styles.taskCard} aria-label={cta}>
      <span className={styles.taskMain}>
        <span className={styles.taskMark} style={{ background: ACTIVATION_STAGE_ACCENTS[stage] }} />

        <h3 className={styles.taskTitle}>{title}</h3>
      </span>

      <span className={styles.taskCta}>
        <IconArrowRight size={14} />
      </span>
    </Link>
  );
}
